import { useMemo } from 'react'
import ScrollSnapWheel from './ScrollSnapWheel'

interface YearWheelPickerProps {
  value: number | null
  onChange: (v: number) => void
  min?: number
  max?: number
  unknown?: boolean
  onUnknown?: () => void
  unknownLabel?: string
  /** Hide inline unknown button (e.g. render in spec-row footer). */
  showUnknownButton?: boolean
  compact?: boolean
}

export default function YearWheelPicker({
  value,
  onChange,
  min = 2007,
  max = new Date().getFullYear() + 1,
  unknown = false,
  onUnknown,
  unknownLabel = "Don't know",
  showUnknownButton = true,
  compact = false,
}: YearWheelPickerProps) {
  const items = useMemo(() => {
    const years: number[] = []
    for (let y = max; y >= min; y -= 1) years.push(y)
    return years
  }, [min, max])

  const scrollValue = value ?? items[0] ?? max

  return (
    <div className={`year-wheel-picker${unknown ? ' year-wheel-picker--unknown' : ''}`}>
      <ScrollSnapWheel
        className="year-scroll-wheel"
        value={scrollValue}
        onChange={onChange}
        items={items}
        ariaLabel="Release year"
        highlightActive={!unknown && value != null}
        compact={compact}
      />
      {showUnknownButton && onUnknown ? (
        <button
          type="button"
          className={`year-wheel-picker__unknown${unknown ? ' year-wheel-picker__unknown--active' : ''}`}
          aria-pressed={unknown}
          onClick={onUnknown}
        >
          {unknownLabel}
        </button>
      ) : null}
    </div>
  )
}
